import { assetUrl } from "fusion-core";

export const assetsPath = {
  // images
  tick: assetUrl("../../assets/icons/tick.svg"),
  forward: assetUrl("../../assets/icons/Forward.svg"),
  previous: assetUrl("../../assets/icons/previous.svg"),
  whiteTick: assetUrl("../../assets/icons/white-tick2.svg"),
  carIcon: assetUrl("../../assets/icons/car-icon.svg"),
  heart: assetUrl("../../assets/icons/Artwork.svg"),
  grayHeart: assetUrl("../../assets/icons/grayArtwork.svg"),
  burgerMenu: assetUrl("../../assets/icons/BurgerMenu.svg"),
  questionMark: assetUrl("../../assets/icons/question-mark.svg"),
  call: assetUrl("../../assets/icons/call.svg"),

  // other Files
  rxpjs: assetUrl("../../features/buy/dist/rxp-js.js"),
};
